import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  savedPropertiesTitle: 'Saved Properties',
  savedProperties: 'Saved Properties',
  savedPropertiesShareAll: 'Share Listings',
  savedPropertiesDeleteAll: 'Delete Favorites',
  savedPropertiesFavoritesTab: 'Favorites',
  savedPropertiesNotesTab: 'With Notes',
  savedPropertiesContactedTab: 'Contacted',
  savedPropertiesAddNote: 'Add your notes here',
  savedPropertiesShareProperty: 'Share Property',
  savedPropertiesDeleteNote: 'Delete Note',
  savedPropertiesReport: 'Report',
  savedPropertiesEmptyTitle: 'No saved properties yet',
  savedPropertiesEmptyDescription:
    'Start saving the listings you care about and they will appear here.',
  savedPropertiesLatest: 'Latest',
  savedPropertiesHighestPrice: 'Highest Price',
  savedPropertiesLowestPrice: 'Lowest Price',
  savedPropertiesLargestArea: 'Largest Area',
  savedPropertiesSmallestArea: 'Smallest Area',
  savedPropertiesCall: 'Call',
  savedPropertiesWhatsapp: 'WhatsApp',
  savedPropertiesEditNotePrompt: 'Write your note',
  savedPropertiesDeleteSingle: 'Remove from favorites',
  savedPropertiesOpenMenu: 'Open property menu',
  pricePerMeterAbbreviation: 'EGP',
  downPayment: 'Down Payment',
  upTo: 'Up to',
  currencyEg: 'EGP',
  millions: 'M',
  thousands: 'K',
  billions: 'B',
  trillion: 'T',
  and: 'and',
  perMonth: 'month',
  pound: 'EGP',
  daily: 'Daily',
  monthly: 'Monthly',
  yearly: 'Yearly',
  weekly: 'Weekly',
  day: 'day',
  days: 'days',
  week: 'week',
  weeks: 'weeks',
  mo: 'mo',
  mos: 'Mos',
  year: 'yr',
  years: 'Yrs',
  noteModalTitle: 'Add Note',
  noteModalPlaceholder: 'Add a note here...',
  character: 'character',
  update: 'Save',
  sortBy: 'Sort by',
  deleteFavoriteConfirm:
    'Are you sure you want to delete all saved properties?',
  deleteFavoriteTitle: 'Delete Saved Properties',
  shareTitle: 'Share Property',
  emptySavedPropertiesTitle: 'You have no saved properties',
  emptySavedNotesTitle: 'You have no properties with notes',
  emptySavedPropertiesButton: 'Start adding now',
  sharePropertiesTitle: 'Share Properties',
  sharePropertiesInfo: 'This link will expire in 7 days',
  shareNotes: 'Share Notes',
  addToFavorites: 'Add to Favorites',
  ads: 'Listings',
  favorite: 'Favorites',
  reportModalTitle: 'Report',
  listingRateFormTitle: 'How was your experience with this listing?',
  listingRateFormIssueTitle: 'What is the issue you are facing?',
  listingRateFormExplainIssue: 'Explain the issue',
  requiredComment: 'Please explain the issue',
  requiredSatisfactionType: 'please select value',
  requiredReason: 'Please select at least one reason',
});
